
/*import {DoccliService} from '../../../providers/DoccliService.js';
const doccliService = new DoccliService();*/
export default {
  data () {
  return {
    initOk:false,
    eligibilite:null,
    id_eligibilite: null,
    service:null,
    offre:null,
    options:[],
    tabs: null,
    text: 'chargement en cours...',    
    loading:false,
    docType:"IDENT",
    piecesToScan:['IDENT_PRIN'],
    hebergeur: "0",
    tiers: "0",
    pieceId:true,
    pieceJustifDom: true,
    pieceIban: true,
    adrTech: null,
    showJustifDom:true,
    showHebergeur:true

  }
},
mounted: function () {
  this.init();
},

  methods: {
    
    initRadioTiersPayeur: function(){
      this.tiers = null;
    },
    initRadioJustifDom: function(){
        this.hebergeur = null;
    },
    scanDocument: function(){
      if(this.pieceJustifDom && this.hebergeur == null){
        this.$dialog.notify.warning("Vous devez choisir la presence d'un hebergeur", {
          position: 'bottom-right',
          timeout: 5000
        })
        return false;
      }

      if(this.pieceIban && this.tiers == null){
        this.$dialog.notify.warning("Vous devez choisir la présence d'un tiers payeur", {
          position: 'bottom-right',
          timeout: 5000
        })
        return false;
      }

      if(this.pieceIban && this.pieceJustifDom){
        this.docType = 'IDENT_IBAN_JUSTIF';
      }else if(this.pieceIban){
        this.docType = 'IDENT_IBAN';
      }else if(this.pieceJustifDom){
        this.docType = 'IDENT_JUSTIF';
      }else
        this.docType = 'IDENT';

      if(!this.pieceIban)
        this.tiers = 0;
      
      if(!this.pieceJustifDom)
        this.hebergeur = 0;

      //initialisation des pieces
      if(this.tiers == 1){
        this.piecesToScan.push('IDENT_TIERS');
      }

      if(this.pieceIban )
        this.piecesToScan.push('IBAN');

      if(this.showJustifDom){
        if(this.hebergeur == 1){
          this.piecesToScan.push('IDENT_HEBERG');
        }
        this.piecesToScan.push('JUSTIF_DOM');
        
      }
      /*
      alert(this.docType +'|tiers:'+this.tiers +' | heberg:'+this.hebergeur);
      if(this.pieceId)
        return false;*/
      this.loading = true;
      //const typeScan = ['ID','IBAN'];
      var optionsSelected = [];
      this.options.forEach(opt => {
        optionsSelected.push(opt.id);
       });
      this.$globalService.setSessionSouscription('existTiersPayeur',this.tiers);
      this.$globalService.setSessionSouscription('existHebergeur',this.hebergeur);
      this.$globalService.setSessionSouscription('piecesToScan',this.piecesToScan);
      this.$router.push({name: 'Cgv'});
      
      //this.$router.push({path: '/souscription/scandocuments'});
    },
    init: async function(){
      //suppression IBAN pour la VAD
      //console.log(this.$root.user.type);
      if(this.$root.user.type == 'VAD'){
        this.pieceIban = false;
      }
      this.$root.progress = true;
      var sessionSouscription = this.$globalService.getSessionSouscription();
      if(!sessionSouscription || !sessionSouscription.eligibilite || !sessionSouscription.serviceChoisi || !sessionSouscription.offreChoisie || !sessionSouscription.optionsChoisies){
        await this.$dialog.error({
          text: "Une erreur s'est produite",
          title: 'Erreur',
          persistent: false,
          actions: {
            false: 'Fermer'
          }
        })
        this.$root.progress = false;
        this.$router.push({name: 'ChoixCategorieOffre'});
      }

      if(this.$root.user.type == 'TLV'){
        this.showHebergeur = false;
       
      }

      //Pas de justif_dom pour porta interne
      if(sessionSouscription.conservNum && sessionSouscription.conservNum == 'O' && !sessionSouscription.codeRIO){
        this.showJustifDom = false;
        this.pieceJustifDom = false;
        //Pas de IBAN pour porta interne 
          this.pieceIban = false;
      }

      if(sessionSouscription.adrTech) {
        this.adrTech = sessionSouscription.adrTech;
      }
      this.$root.progress = false;
      this.eligibilite = sessionSouscription.eligibilite;
      this.id_eligibilite = sessionSouscription.eligibilite.id_eligibilite.substr(0,4) +' '+ sessionSouscription.eligibilite.id_eligibilite.substr(4,4) +' '+ sessionSouscription.eligibilite.id_eligibilite.substr(8,4) +' '+ sessionSouscription.eligibilite.id_eligibilite.substr(12,2);
      this.service = sessionSouscription.serviceChoisi;
      this.offre= sessionSouscription.offreChoisie;
      this.options = sessionSouscription.optionsChoisies
      this.initOk = true;
      //await this.$nextTick()
    }
  }
}